import { render } from "./ImpressionsInventoryExports.vue?vue&type=template&id=4c8ac944"
import script from "./ImpressionsInventoryExports.vue?vue&type=script&lang=js"
export * from "./ImpressionsInventoryExports.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__